<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="成果申报申请" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" v-if="editData.djzt === '提交'" type="danger" @click="onCancel">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="9">
                                        <a-form-item label="申报表编号">
                                            <a-input ref="cgsbbbh" v-model="editData.cgsbbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="申报日期">
                                            <!-- <a-date-picker ref="sbrq" v-model="editData.sbrq" :default-value="moment(sbrq, dateFormat)" :format="dateFormat" required /> -->
                                            <a-input ref="sbrq" v-model="editData.sbrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="申报年份">
                                            <FGDictSelectCN ref="sbnf" dictNo="P0002" v-model="editData.sbnf" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="申报单位编号">
                                            <a-input ref="sbdwbh" v-model="editData.sbdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="申报单位名称">
                                            <a-input ref="sbdwmc" v-model="editData.sbdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="单位类别">
                                            <a-input ref="dwlb" v-model="editData.dwlb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="工程咨询单位备案编号">
                                            <a-input ref="babh" v-model="editData.babh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="地址">
                                            <a-input ref="xxdz" v-model="editData.xxdz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="邮政编码">
                                            <a-input ref="yzbm" v-model="editData.yzbm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="联系人1">
                                            <a-input ref="lxr" v-model="editData.lxr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="联系电话1">
                                            <a-input ref="lxdh" v-model="editData.lxdh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="联系人2">
                                            <a-input ref="lxr1" v-model="editData.lxr1" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="联系电话2">
                                            <a-input ref="lxdh1" v-model="editData.lxdh1" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" :precision="2" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入日期">
                                            <a-date-picker ref="lrrq" v-model="editData.lrrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="18">
                                        <a-form-item label="(合规审核)审核意见" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                            <a-textarea ref="shyj" :rows="3" v-model="editData.shyj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="18">
                                        <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 成果申报表明细表格 -->
                        <FGCollapsiblePanel title="江苏省优秀工程咨询成果评选申报表">
                            <vxe-table
                                ref="CGSBBitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataCGSBB"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                <vxe-table-column field="xmmc" title="成果名称" width="200">
                                    <template slot-scope="scope">
                                        <div :style="{ color: scope.row.cgysjg === '否决' ? 'red' : '#0099ff' }" @click="cellClick(scope.row)">
                                            {{ scope.row.xmmc }}
                                        </div>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zymc" title="专业名称" width="150"></vxe-table-column>
                                <vxe-table-column field="cglx" title="成果类型" width="120" align="center"></vxe-table-column>
                                <!--                                <vxe-table-column field="cgsbdj" title="申报等级" width="120" align="center"> </vxe-table-column>
                                <vxe-table-column field="xmmj" title="项目密级" width="120" align="center"> </vxe-table-column>-->
                                <vxe-table-column field="cgkssj" title="成果开始时间" width="150" align="center"></vxe-table-column>
                                <vxe-table-column field="cgwcsj" title="成果完成时间" width="150" align="center"></vxe-table-column>
                                <vxe-table-column field="qtzywcdw" title="其他主要完成单位" width="200"></vxe-table-column>
                                <vxe-table-column
                                    field="nrty"
                                    title="内容提要（简明扼要介绍成果背景，工作过程，500字以内）"
                                    show-header-overflow="tooltip"
                                    width="300"
                                ></vxe-table-column>
                                <vxe-table-column
                                    field="cgtdjsbly"
                                    title="成果特点及申报理由（参照《江苏省优秀工程咨询成果水平评价办法》所列的评选标准，直叙在申报成果中所做的咨询工作特点，要有利于评审专家和评委了解申报单位咨询工作的优秀之处。要求条理清晰，简明扼要，理由充分，特点突出。1500字以内。）"
                                    show-header-overflow="tooltip"
                                    width="300"
                                ></vxe-table-column>
                                <vxe-table-column field="spyjzy" title="审批（核准）意见摘要" width="300"></vxe-table-column>
                                <vxe-table-column field="pgyjzy" title="评估（评审、审查）意见摘要" width="300"></vxe-table-column>
                                <vxe-table-column field="pjjdyjzy" title="评价、鉴定意见摘要" width="300"></vxe-table-column>
                                <vxe-table-column field="qtzy" title="其他摘要" width="300"></vxe-table-column>
                                <vxe-table-column field="sbdwyj" title="申报单位意见" width="300"></vxe-table-column>
                                <!-- <vxe-table-column field="cgcyry" title="成果参与人员" width="150"></vxe-table-column>
                                <vxe-table-column field="wtdw" title="委托单位" width="150"></vxe-table-column>
                                <vxe-table-column field="sfsm" title="是否涉密" width="150"></vxe-table-column>
                                <vxe-table-column field="fwfw" title="服务范围" width="150"></vxe-table-column>
                                <vxe-table-column field="xmztz" title="项目总投资(万元)" width="150"></vxe-table-column>
                                <vxe-table-column field="ghjb" title="规划级别" width="150"></vxe-table-column>
                                <vxe-table-column field="cggk" title="成果概况" width="150"></vxe-table-column>
                                <vxe-table-column field="cgyyqk" title="成果应用情况" width="150"></vxe-table-column> -->
                                <vxe-table-column field="bz" title="备注" width="200"></vxe-table-column>
                                <!-- <vxe-table-column field="fj" title="附件" width="150" align="center">
                                    <template v-slot="scope">
                                        <UploadButton :field="scope.row.id" :attachCfg="attachCfg_Edit" :state="2" :btnType="2" />
                                    </template>
                                </vxe-table-column> -->
                                <vxe-table-column title="成果相关附件" width="150" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="zlmxView(scope.row)">查看</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column title="曾获奖励情况" width="160" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="hjqkmxView(scope.row)">查看</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column title="主要完成人情况（含排序）" width="175" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="wcrqkmxView(scope.row)">查看</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                    </a-spin>
                    <!-- 流程跟踪组件 -->
                    <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
        <HjqkmxForm :showHjqkmxEdit.sync="editProps.showHjqkmxEdit" :dataId="editProps.dataId" :cgsbbmxid="editProps.cgsbbmxid" @dataUpdated="loadData" />
        <WcrqkmxForm :showWcrqkmxEdit.sync="editProps1.showWcrqkmxEdit" :dataId="editProps1.dataId" :cgsbbmxid="editProps1.cgsbbmxid" @dataUpdated="loadData" />
        <ZlmxForm :showZlmxEdit.sync="editProps2.showZlmxEdit" :dataId="editProps2.dataId" :cgsbbmxid="editProps2.cgsbbmxid" @dataUpdated="loadData" />
        <CgsbcxmxView
            :showCgsbcxmxView.sync="editProps4.showCgsbcxmxView"
            :dataId="editProps4.dataId"
            :cgsbbmxid="editProps4.cgsbbmxid"
            @dataUpdated="loadData"
        />
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import HjqkmxForm from "./HjqkmxForm";
import WcrqkmxForm from "./WcrqkmxForm";
import ZlmxForm from "./ZlmxForm";
import CgsbcxmxView from "./CgsbcxmxView";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
import moment from "moment";
export default {
    name: "CgsbwhEdit",
    components: { HjqkmxForm, WcrqkmxForm, ZlmxForm, CgsbcxmxView },
    props: ["showView", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            dateFormat: "YYYY-MM-DD",
            saving: false,
            isShow1: false,
            isShow2: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            editItemDataCGSBB: [],
            editItemDataCGSBBLoading: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null,
                hiddenZZXM: true
            },
            editProps: {
                showHjqkmxEdit: false,
                dataId: null,
                cgsbbmxid: ""
            },
            editProps1: {
                showWcrqkmxEdit: false,
                dataId: null,
                cgsbbmxid: ""
            },
            editProps2: {
                showZlmxEdit: false,
                dataId: null,
                cgsbbmxid: ""
            },
            editProps4: {
                showCgsbcxmxView: false,
                dataId: null,
                cgsbbmxid: ""
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        viewIsVisible: {
            get() {
                return this.showView;
            },
            set(newVal) {
                this.$emit("update:showView", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                fktable: "CG_CGSBB",
                fkvalue: this.editData.id,
                attachsource: "CG1001"
            };
        },
        attachCfg_Edit() {
            return {
                fktable: "CG_CGSBB",
                fkvalue: this.editData.id,
                attachsource: "CG1001"
            };
        }
    },
    activated() {
        // 修改，加载数据
        this.loadData();
        // 加载明细数据
        this.loadItemDataCGSBB();
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.cgsbbbh.focus();
        });
    },
    methods: {
        moment,
        saveEvent(val) {
            if (val && val.length > 0) {
                this.editData.qybh = val[0][0].QYBH;
                this.editData.qymc = val[0][0].QYMC;
                this.editData.qyid = val[0][0].ID;
            }
        },
        saveEvent1(val) {
            if (val && val.length > 0) {
                this.editData.hyfl = val[0][0].ZYMC;
            }
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            // this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.viewIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.viewIsVisible = false;
                    }
                });
        },
        // 加载明细表数据
        loadItemDataCGSBB() {
            this.editItemDataCGSBB = [];
            this.editItemDataCGSBBLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemCGSBB",
                    {
                        cgsbbid: this.editDataId,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataCGSBBLoading = false;
                    if (success) {
                        this.editItemDataCGSBB = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        //撤销操作
        onCancel(type) {
            this.$FG_message.confirm("P0000", "撤销").then((type) => {
                if (type === "ok") {
                    this.loading = true;
                    this.$FG_http
                        .post("./api/main/zxcggl/cgsbgl/back", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.saving = false;
                            if (success) {
                                // 设置当前行
                                this.lookDataId = this.editData.id;
                                // 返回列表
                                this.viewIsVisible = false;
                            }
                        });
                }
            });
        },
        // 返回列表
        onBack() {
            this.viewIsVisible = false;
        },
        //加载操作日志
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        },
        // 资料明细
        zlmxView(row) {
            // 设置编辑记录id
            this.editProps2.dataId = this.editData.id;
            this.editProps2.cgsbbmxid = row.id;
            // 显示编辑窗口
            this.editProps2.showZlmxEdit = true;
        },
        // 获奖情况明细
        hjqkmxView(row) {
            // 设置编辑记录id
            this.editProps.dataId = this.editData.id;
            this.editProps.cgsbbmxid = row.id;
            // 显示编辑窗口
            this.editProps.showHjqkmxEdit = true;
        },
        // 完成人情况明细
        wcrqkmxView(row) {
            // 设置编辑记录id
            this.editProps1.dataId = this.editData.id;
            this.editProps1.cgsbbmxid = row.id;
            // 显示编辑窗口
            this.editProps1.showWcrqkmxEdit = true;
        },
        //单击明细列表展示明细详情
        cellClick(row) {
            // 设置编辑记录id
            this.editProps4.dataId = this.editData.id;
            this.editProps4.cgsbbmxid = row.id;
            // 显示编辑窗口
            this.editProps4.showCgsbcxmxView = true;
        }
    }
};
</script>
<style lang="scss" scoped></style>
